import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { LicensesModule } from '../licenses/licenses.module';
import { StudentsRoutingModule } from './students-routing.module';
import { StudentsQuestionsService } from './students-questions.service';
import { StudentsImportComponent } from './students-import/students-import.component';
import { StudentsListComponent } from './students-list/students-list.component';
import { StudentDetailComponent } from './student-detail/student-detail.component';
import { StudentsComponent } from './students/students.component';
import { StudentEditorComponent } from './student-editor/student-editor.component';
import { StudentEditorPopupComponent } from './student-editor-popup/student-editor-popup.component';
import { StudentCreateComponent } from './student-create/student-create.component';
import { StudentsBatchCreateComponent } from './students-batch-create/students-batch-create.component';
import { EmailsModule } from '../emails/emails.module';
import { StudentsInviteComponent } from './students-invite/students-invite.component';
import { StudentsInviteQuestionsService } from './students-invite/students-invite-questions.service';
import { UiService } from '../core/services/ui.service';
import { StudentEmailEditorComponent } from './student-email-editor/student-email-editor.component';

@NgModule({
  imports: [CommonModule, CoreModule, LicensesModule, StudentsRoutingModule, EmailsModule],
  declarations: [
    StudentsImportComponent,
    StudentsListComponent,
    StudentDetailComponent,
    StudentsComponent,
    StudentEditorComponent,
    StudentEmailEditorComponent,
    StudentEditorPopupComponent,
    StudentCreateComponent,
    StudentsInviteComponent,
    StudentsBatchCreateComponent
  ],
  exports: [
    StudentsListComponent,
    StudentsImportComponent,
    StudentEditorComponent,
    StudentEmailEditorComponent,
    StudentsComponent,
    StudentsBatchCreateComponent
  ],
  providers: [StudentsQuestionsService, StudentsInviteQuestionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class StudentsModule {
  constructor(public uiService: UiService) {}
}
